import React from "react"
import PropTypes from 'prop-types'

const CloseIcon = ({
  fill = "#fff",
  className = "",
  viewBox = "0 0 100 100"
}) => (
  <svg viewBox={viewBox} xmlns="http://www.w3.org/2000/svg" className={`svg-icon ${className}`}>
    <path d="m52.918 50 16.457-16.457c0.83203-0.83203 0.83203-2.082 0-2.918-0.83203-0.83203-2.082-0.83203-2.918 0l-16.457 16.457-16.457-16.457c-0.83203-0.83203-2.082-0.83203-2.918 0-0.83203 0.83203-0.83203 2.082 0 2.918l16.457 16.457-16.457 16.457c-0.83203 0.83203-0.83203 2.082 0 2.918 0.41797 0.41797 1.043 0.625 1.457 0.625 0.41797 0 1.043-0.20703 1.457-0.625l16.457-16.457 16.457 16.457c0.41797 0.41797 1.043 0.625 1.457 0.625 0.41797 0 1.043-0.20703 1.457-0.625 0.83203-0.83203 0.83203-2.082 0-2.918z" fill={fill} />
  </svg>
)

CloseIcon.propTypes = {
  fill: PropTypes.string,
  className: PropTypes.string,
  viewBox: PropTypes.string
}

export default CloseIcon
